import React, { memo } from 'react';
import { observer } from 'mobx-react-lite';
import { roundTimeStore } from '../../store/roundTimeStore';
import { gameStore } from '../../store/gameStore';
import { cardsStore } from '../../store/cardsStore';

export const Timer = memo(
  observer(() => {
    const { time } = roundTimeStore;
    const { isShuffle } = cardsStore;
    const { isBetsClosed } = gameStore;

    if (time === null || isBetsClosed || isShuffle) {
      return null;
    }
    return (
      <div className='place-bets-box'>
        <span className='place-bets-box-text'>{time}</span>
      </div>
    );
  })
);
